<div class="refine-panel" [style.z-index]="zIndex | async">

  <canvas #refineOverlay class="refine-overlay" [class.hide]="mode !== 'EDIT'"></canvas>

  <div #refineContainer id="refine-container"></div>

  <div class="refine-side-bar" [style.left]="getSaveBtnPosX()" [style.top]="getSaveBtnPosY()" >
    <div>
      <button *ngIf="mode === 'EDIT'" (click)="onSave()" class="btn btn-primary btn-refine-save">{{'redesign.refineCorners.save' | translate}}</button>
    </div>
    <canvas #refineZoom class="refine-zoom" [class.show]="showZoom" width="200" height="200"></canvas>
  </div>

  <div class="visual-bounds-container" *ngIf="currentlyShowingCorners || (customerConfig$ | async)?.alwaysShowImageButtons"
       [style.left]="toCSSPixel(getVisualBounds().x)"
       [style.top]="toCSSPixel(getVisualBounds().y)"
       [style.width]="toCSSPixel(getVisualBounds().width)"
       [style.height]="toCSSPixel(getVisualBounds().height)"
  >
    <div class="refine-button-container"
         [ngClass]="{
         'line': (customerConfig$| async)?.imageButtonsArrangement === ImageButtonsArrangement.Line,
         'stacked': (customerConfig$| async)?.imageButtonsArrangement === ImageButtonsArrangement.Stacked,
         'left': (customerConfig$| async)?.imageButtonsPlacement === ImageButtonsPlacement.Left,
         'right': (customerConfig$| async)?.imageButtonsPlacement === ImageButtonsPlacement.Right
         }"
    >
      <!-- Toggle clipped corners button -->
      <button *ngIf="(currentScenarioType$ | async) === 'USER' && allowClippedCorners" class="btn btn-primary btn-add-door" (click)="onToggleClippedCorners()">
        <i class="m-icon screenshot-frame"></i>
        {{'redesign.refineCorners.clippedCorners' | translate}}
      </button>

      <!-- Add door button -->
      <button *ngIf="allowMultipleDoors" class="btn btn-primary btn-add-door" (click)="onAddDoor()"><i class="m-icon plus"></i>{{'redesign.refineCorners.addDoor' | translate}}</button>

      <!-- Refine corners button -->
      <button *ngIf="(currentScenarioType$ | async) === 'USER' &&  mode === 'PREVIEW' || mode === 'PREVIEW_WITH_TEMP_CORNERS'"
              (click)="onRefine()" class="btn btn-primary btn-refine">
        <i class="m-icon refine"></i> {{'redesign.refineCorners.refine' | translate}}
      </button>

    </div>
  </div>

  <div class="save-in-progress" *ngIf="isSaveInProgress$ | async">
    <div class="spinner-border text-primary" style="width: 60px; height: 60px" role="status">
    </div>
  </div>
</div>
